// extracted by mini-css-extract-plugin
export default {"container":"header-icons__container___MHjs3","icon":"header-icons__icon___kaS0q","tooltip":"header-icons__tooltip___kslIS"};